(function () {
  'use strict';

  angular.module('app').component('tourContentPage', TourContentPageComponent());

  function TourContentPageComponent() {
    return {
      bindings: {},
      controller: TourContentDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/tour-contents/tour-content-page.component.html',
    };
  }

  TourContentDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'LanguageService',
    'TourContentService',

    // Angular downgraded service
    'sessionService',
  ];

  function TourContentDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    LanguageService,
    TourContentService,

    // Angular downgraded service
    sessionService
  ) {
    var vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_tour_accountadmin'),
    };

    var itemId = $routeParams.id;
    vm.tourId = $routeParams.tourId; // optional from modal
    vm.websiteId = $routeParams.WSID;

    // Methods
    vm.onTourContentSaved = onTourContentSaved;
    vm.onTourContentCanceled = onTourContentCanceled;

    // Initializers
    getLanguages();
    // getTourContent();

    function getLanguages() {
      const websiteStored = sessionService
        .getSelectedAccountCompany()
        .websites.find((x) => x.id === vm.websiteId);

      // console.log(websiteStored);

      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        const languages = data.items;

        // console.log(websiteStored);
        // console.log(languages);

        vm.defaultLanguage = languages.find((x) => x.id === websiteStored.language_id).lang; // use .lang

        // console.log(vm.defaultLanguage);

        vm.additionalLanguages = languages
          .filter((x) => websiteStored.language_ids.includes(x.id))
          .filter((y) => y.id !== websiteStored.language_id);

        // vm.defaultLanguage = languages.filter((language) => language.is_default)[0].lang;
        // vm.additionalLanguages = languages.filter((language) => !language.is_default);

        // console.log(vm.defaultLanguage);
        // console.log(vm.additionalLanguages);

        getTourContent();
      });
    }

    function getTourContent() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        TourContentService.getTourContent(itemId, vm.defaultLanguage).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onTourContentSaved(item) {
      $location.path(`/tour_contents/${item.id}`).search({ WSID: vm.websiteId });
    }

    function onTourContentCanceled() {
      $location.path(`/tour_contents`).search({ WSID: vm.websiteId });
    }
  }
})();
